import { combineReducers } from "redux";
import contactus from "../features/admin/form/contactus/Slice";
import enquiry from "../features/admin/form/enquiry/Slice";

const form = combineReducers({
    contactus: contactus,
    enquiry: enquiry,
})


export default form;